const uuid=(x:unknown):x is string=>typeof x==='string'&&/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(x);
export interface FirstWorkPlan {
 leadId:string;activityId:string;pipelineId:string;stageId:string;
 name:string;email:string;source:'website'|'referral'|'ads'|'manual'|'other';
 title:string;type:'call'|'email'|'appuntamento';dueAt:string;
}
export function validFirstWorkPlan(value:unknown):value is FirstWorkPlan {
 if(!value||typeof value!=='object'||Array.isArray(value))return false;
 const p=value as FirstWorkPlan;
 return [p.leadId,p.activityId,p.pipelineId,p.stageId].every(uuid)&&p.leadId!==p.activityId
 &&typeof p.name==='string'&&p.name.trim().length>0&&p.name.length<=150
 &&typeof p.title==='string'&&p.title.trim().length>0&&p.title.length<=150
 &&typeof p.email==='string'&&p.email.length<=254&&(!p.email||/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(p.email))
 &&['website','referral','ads','manual','other'].includes(p.source)
 &&['call','email','appuntamento'].includes(p.type)
 &&typeof p.dueAt==='string'&&/^\d{4}-\d{2}-\d{2}T.*(?:Z|[+-]\d{2}:\d{2})$/.test(p.dueAt)&&Number.isFinite(Date.parse(p.dueAt));
}

export interface FirstWorkDraft {plan:FirstWorkPlan;attempted:boolean;step:number}
/** Storage is a conversation draft, never proof that CRM writes succeeded. */
export function restoreFirstWorkDraft(raw:unknown,pipelineId:string,stageId:string):FirstWorkDraft|null{
 if(!raw||typeof raw!=='object'||Array.isArray(raw))return null;
 const s=raw as FirstWorkDraft,p=s.plan;
 if(!p||p.pipelineId!==pipelineId||p.stageId!==stageId||typeof s.attempted!=='boolean'
  ||!Number.isInteger(s.step)||s.step<0||s.step>6
  ||typeof p.name!=='string'||typeof p.title!=='string'||typeof p.dueAt!=='string')return null;
 const candidate=s.attempted||s.step===6?p:{...p,name:p.name||'Bozza',title:p.title||'Bozza',dueAt:p.dueAt||'2080-01-01T00:00:00Z'};
 return validFirstWorkPlan(candidate)?{plan:p,attempted:s.attempted,step:s.step}:null;
}
